import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface AccordionSection {
  type:string;
  testcase?: string;
  filename?: string;
  expanded?: boolean;
  error: boolean;
  suggestions?: any[];
}

@Component({
  selector: 'app-accordion-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accordion-content.component.html',
  styleUrl: './accordion-content.component.scss'
})
export class AccordionContentComponent {
  @Input() sections: AccordionSection[] = [];

  toggleSection(section: AccordionSection) {
    section.expanded = !section.expanded;
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  hasSuggestions(suggestions: any): boolean {
    if (!suggestions) return false;
    if (typeof suggestions === 'string') return suggestions.trim().length > 0;
    if (Array.isArray(suggestions)) return suggestions.length > 0;
    return false;
  }
}
